<template>
    <div class="modal">
        <div class="modal-content">
            <span class="close" @click="$emit('close')">&times;</span>
            <h2>{{ placeholder.placeholder }}</h2>
            <p><strong>Path:</strong> {{ placeholder.xpath }}</p>
            <p><strong>Value:</strong> {{ xmlValue }}</p>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'XPathValueModal',
    props: {
        index: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            xmlValue: ''
        };
    },
    computed: {
        ...mapState(['xPathPlaceholders']),
        placeholder() {
           if(this.xPathPlaceholders[this.index]) return this.xPathPlaceholders[this.index];
        }
    },
    watch: {
        placeholder: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.fetchXMLValue(newVal.path);
                }
            }
        }
    },
    methods: {
        fetchXMLValue(path) {
            this.xmlValue = this.placeholder.value;
        }
    },
    mounted(){
        if(this.xPathPlaceholders[this.index].length > 0) this.fetchXMLValue(this.placeholder.xpath);
    }
};
</script>

<style scoped>
.modal {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 30px;
    border: 1px solid #888;
    width: 600px;
    text-align: left;
}

p{
    word-wrap: break-word;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
</style>